var _style, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFinaerAltGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 203",
    style: {
      enableBackground: "new 0 0 595.3 203"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.5,147.8l13.9,13.9c-9.6,9.6-21.1,14.2-34.5,14.2s-25-4.7-34.5-14.2c-9.6-9.6-14.2-21.1-14.2-34.5 c0-13.5,4.7-25,14.2-34.5c9.6-9.6,21.1-14.2,34.5-14.2s25,4.7,34.5,14.2c12.3,12.5,16.8,27.3,13.5,44.3h-75.7 c1.6,4.1,3.9,7.8,7,10.9c5.7,5.7,12.7,8.6,20.7,8.6C451.8,156.3,458.8,153.4,464.5,147.8z M423.1,106.4c-3.1,3.3-5.5,6.8-7,10.9 h55.4c-1.4-4.1-3.7-7.6-7-10.9c-5.7-5.7-12.7-8.6-20.7-8.6C435.8,97.8,428.8,100.7,423.1,106.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.0444,
    y1: 92.7916,
    x2: 550.6902,
    y2: 92.7916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2639,
    style: {
      stopColor: "#848484"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4984,
    style: {
      stopColor: "#979797"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7406,
    style: {
      stopColor: "#A2A2A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6A6A6"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M535.6,106.4c5.7-5.7,12.7-8.6,25.7-8.6V78.3c-15.8,0-25.5,3.3-34.3,9.8l-9.8-9.8h-9.8v18.3l21,21 C529.9,113.4,532.3,109.7,535.6,106.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "507.5,175.9 527,175.9 527,130.5 507.5,111.2  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190,125.9v50h-19.5V78.3h9.8L190,88c8.8-6.4,18.5-9.8,29.3-9.8c13.5,0,25,4.7,34.5,14.2 c9.6,9.6,14.3,21.1,14.3,34.5v48.8h-19.5v-48.8c0-8-2.9-15-8.6-20.7c-5.7-5.7-12.7-8.6-20.7-8.6c-8,0-14.6,2.7-20.3,8.2 C193.3,111.4,190.2,118.1,190,125.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.1,92.5c-1.7-1.7-3.5-3.2-5.3-4.6V88c-6.6-4.8-13.7-7.9-21.4-9.1c-0.1,0-0.2,0-0.3,0 c-1.1-0.2-2.3-0.3-3.4-0.4c-1.4-0.1-2.8-0.2-4.3-0.2c-1.5,0-2.9,0.1-4.4,0.2c-0.9,0.1-1.8,0.2-2.7,0.3c-0.4,0.1-0.8,0.1-1.2,0.2 c-7.6,1.3-14.6,4.3-21,9.1l0,0c-1.8,1.4-3.6,2.9-5.2,4.5c-9.6,9.6-14.2,21.1-14.2,34.5c0,13.5,4.7,25,14.2,34.5 c1.7,1.7,3.5,3.2,5.3,4.6v-0.1c6.6,4.8,13.7,7.9,21.4,9.1c0.1,0,0.2,0,0.3,0c1.1,0.2,2.3,0.3,3.4,0.4c1.4,0.1,2.8,0.2,4.3,0.2 c1.5,0,2.9-0.1,4.4-0.2c0.9-0.1,1.8-0.2,2.7-0.3c0.4-0.1,0.8-0.1,1.2-0.2c7.6-1.3,14.6-4.3,21-9.1l0,0l9.7,9.7h9.8v-48.8 C380.3,113.6,375.7,102.1,366.1,92.5z M360.8,127.1C360.8,127.1,360.8,127.1,360.8,127.1c0,8-2.9,15-8.6,20.7 c-5.7,5.7-12.7,8.6-20.7,8.6c-8,0-15-2.9-20.7-8.6c-0.7-0.7-1.4-1.4-2-2.2c-3.6-4.3-5.7-9.3-6.4-14.8c-0.1-1.2-0.2-2.4-0.2-3.7 c0,0,0,0,0,0c0,0,0,0,0,0c0-8,2.9-15,8.6-20.7c5.7-5.7,12.7-8.6,20.7-8.6c8,0,15,2.9,20.7,8.6c0.7,0.7,1.3,1.4,1.9,2.1 c3.6,4.3,5.8,9.4,6.5,15C360.7,124.6,360.8,125.8,360.8,127.1C360.8,127.1,360.8,127.1,360.8,127.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,29.5V49H53.4v43.9h43.9v19.5H53.4v63.4H33.9V29.5H116.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.1,40.6c0-3.3,1.2-6.3,3.5-8.4c2.2-2.4,5.1-3.5,8.4-3.5c3.3,0,6.1,1.2,8.2,3.5c2.4,2.4,3.5,5.1,3.5,8.4 c0,3.3-1.2,6.1-3.5,8.2c-2.2,2.4-4.9,3.5-8.2,3.5c-3.3,0-6.1-1.2-8.4-3.5C131.3,46.6,130.1,43.9,130.1,40.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 78.3,
    className: "st0",
    width: 19.5,
    height: 97.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFinaerAltGrey);
export default __webpack_public_path__ + "static/media/logo-finaer-alt-grey.d7c83b1a7f43d2236cd7eac1db499b16.svg";
export { ForwardRef as ReactComponent };